/*
  ap customization: 初回ロード時の共通バナーオーバーレイ制御
  --------------------------------------------------------------------------
  背景 / 方針:
    商品ページの初回ロード時は、商品共通のメイン画像（ブランドバナー）を
    最初に見せたい（クライアントのマーケ要望①）。一方、カラー選択(②)や
    バリエーション挙動は StarApps（Default behavior）に任せるのが最も自然で確実。

    そこで「ギャラリーのメイン画像エリアに common バナーを SSR で被せて
    （= product-media-gallery.liquid の .ap-banner-overlay）初回は必ずバナーを見せ」、
    ユーザーが画像/サムネイルエリア または カラー等を操作したらオーバーレイを外して
    下にある通常ギャラリー（選択中バリエーションの画像）を見せる。

    この方式により、native <select> の「同値再選択(reclick)が検知できない」問題を
    回避できる（バナーを外せば既に色画像が active なので reclick 自体が不要）。

  注意:
    バグ修正ではなくマーケ要望に基づく意図的カスタマイズ。テーマ更新時は再適用が必要。
    オーバーレイ本体（HTML/CSS）は snippets/product-media-gallery.liquid 側にある。
*/
(function () {
  "use strict";

  function dismiss() {
    // 一度解除したら、このページ表示中は二度と出さない。
    // バリエーション変更で gallery が再描画され overlay が新品で再生成されても、
    // <html> のクラスを CSS で受けて確実に隠し続ける（＝初回入室時のみ被せる）。
    document.documentElement.classList.add("ap-banner-dismissed");
    var banners = document.querySelectorAll("[data-ap-banner]:not(.is-hidden)");
    for (var i = 0; i < banners.length; i++) {
      banners[i].classList.add("is-hidden");
    }
  }

  // 画像/サムネイルエリア（media-gallery 内）または カラー等（variant-selects /
  // .product-form__input）を操作したらオーバーレイを外す。
  // variant 変更で gallery が部分再描画されても効くよう document へ委譲（capture）。
  function onInteract(e) {
    // プログラム発火（StarApps 等が dispatchEvent するロード時の同期イベント）は無視し、
    // 実ユーザーの操作だけで解除する。これが無いとロード直後に即解除されてしまう。
    if (!e.isTrusted) return;
    if (e.target.closest && e.target.closest("media-gallery, variant-selects, .product-form__input")) {
      dismiss();
    }
  }

  // pointerdown を見るのが肝。native <select> は同値再選択で click / change が
  // 発火しない（特に Safari）ため、カラー等を「触った瞬間」で解除する。
  document.addEventListener("pointerdown", onInteract, true);
  document.addEventListener("click", onInteract, true);
  document.addEventListener("change", onInteract, true);
})();
